<template>
  <el-dialog :visible="isShowDialog" width="85%" @close="onClosePopupButtonClick()">
    <el-container>
      <el-main v-loading="isLoading">
        <div style="margin-bottom: 20px">
          <span style="font-size: 20px"><strong>{{$t('subject')}}: </strong>{{emailHistory.subject}} </span>
        </div>
        <div class="container-total-item">
          <div class="total-item">
            <div class="total-item-text send">
              <strong>{{$t('totalSendEmail')}}</strong> <br>
              <span style="font-size: 20px">{{historyResultList.length}} </span>
            </div>
          </div>
          <div class="total-item">
            <div class="total-item-text success">
              <strong>{{$t('success')}}</strong> <br>
              <span style="font-size: 20px">{{getTotalWithStatus(EMAIL_STATUS.SUCCESS)}}</span>
            </div>
          </div>
          <div class="total-item">
            <div class="total-item-text fail">
              <strong>{{$t('fail')}}</strong> <br>
              <span style="font-size: 20px">{{getTotalWithStatus(EMAIL_STATUS.FAIL)}}</span>
            </div>
          </div>
          <div class="total-item">
            <div class="total-item-text processing">
              <strong>{{$t('processing')}}</strong> <br>
              <span style="font-size: 20px">{{getTotalWithStatus(EMAIL_STATUS.PROCESSING)}}</span>
            </div>
          </div>
        </div>
        <div class="filter-container">
          <el-row>
            <el-col :span="6">
              <el-input size="small"
                        v-model="keyword"
                        :placeholder="$t('filterByKeyword')"></el-input>
            </el-col>
            <el-col :span="1" style="padding-left: 3px">
              <el-button type="default"
                         @click="keyword = ''"
                         size="small">{{$t('clear')}}
              </el-button>
            </el-col>
            <el-col :span="6" style="padding-left: 10px">
              <span style="margin-right: 10px">Record per pages</span>
              <el-select v-model="pageSize" size="small" placeholder="Select">
                <el-option
                  v-for="item in pageSizeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
        <div>
          <el-table :data="historyResultDisplayList">
            <el-table-column :label="$t('email')">
              <template slot-scope="scope">
                <strong>{{bindEmailSendType(scope.row.email)}}</strong> {{scope.row.email}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('agent')">
              <template slot-scope="scope">
                {{bindAgent(scope.row.agentId)}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('agentType')">
              <template slot-scope="scope">
                {{bindAgentType(scope.row.agentId)}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('market')">
              <template slot-scope="scope">
                {{bindMarket(scope.row.agentId)}}
              </template>
            </el-table-column>
            <el-table-column :label="$t('status')">
              <template slot-scope="scope">
                <span class="processing" v-if="scope.row.sendStatus === EMAIL_STATUS.PROCESSING"> Processing</span>
                <span class="success" v-if="scope.row.sendStatus === EMAIL_STATUS.SUCCESS"> Success</span>
                <span class="fail" v-if="scope.row.sendStatus === EMAIL_STATUS.FAIL"> Fail</span>
              </template>
            </el-table-column>
            <el-table-column :label="$t('detail')">
              <template slot-scope="scope">
                {{scope.row.sendDetail}}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="margin-top: 10px">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="historyResultList.length"
            :page-size="pageSize"
            :current-page="currentPage"
            @current-change = "changePage">
          </el-pagination>
        </div>
      </el-main>
    </el-container>
  </el-dialog>
</template>
<script>
import i18nMessages from '@/translations/Email/ManageEmail/EmailHistory/components/PopupEmailHistoryResultListComponent.i18n'
import EmailApi from '@/api/email-api'
import { get } from 'lodash'
import { EMAIL_STATUS } from '@/configs/constant'
import { filterDataByKeyword, getDataOnPaging } from '@/services/general-service'

export default {
  name: 'PopupEmailHistoryResultListComponent',
  i18n: { messages: i18nMessages },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    emailHistory: {
      type: Object,
      default: () => {
        return {}
      }
    },
    agentList: {
      type: Array,
      default: () => {
        return []
      }
    },
    agentTypeList: {
      type: Array,
      default: () => {
        return []
      }
    },
    marketList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    visible: function (newValue) {
      this.isShowDialog = newValue
      if (newValue === true) {
        this.initData()
      }
    }
  },
  data () {
    return {
      isShowDialog: false,
      historyResultList: [],
      EMAIL_STATUS,
      keyword: '',
      currentPage: 1,
      pageSize: 10,
      isLoading: true,
      pageSizeOptions: [{
        value: 10,
        label: '10'
      }, {
        value: 20,
        label: '20'
      }, {
        value: 50,
        label: '50'
      }, {
        value: 100,
        label: '100'
      }, {
        value: 999,
        label: 'All'
      }
      ]
    }
  },
  computed: {
    historyResultDisplayList: function () {
      const filterHistoryResultList = this._filter()
      return getDataOnPaging(filterHistoryResultList, this.currentPage, this.pageSize)
    }
  },
  methods: {
    initData: async function () {
      this.isLoading = true
      try {
        this.historyResultList = await EmailApi.historyResultList(this.emailHistory.id)
        this.pageSizeOptions[4].value = this.historyResultList.length
      } catch (err) {
        this.alertError(err.message)
      }
      this.isLoading = false
    },
    bindAgent: function (agentId) {
      const agent = this.agentList.find(agent => Number(agent.id) === Number(agentId))
      const agentName = get(agent, 'name', '')
      return agentName
    },
    bindAgentType: function (agentId) {
      const agent = this.agentList.find(agent => Number(agent.id) === Number(agentId))
      const agentTypeId = get(agent, 'agentTypeId', '')
      const agentType = this.agentTypeList.find(agentType => Number(agentType.id) === Number(agentTypeId))
      const agentTypeName = get(agentType, 'name', '')
      return agentTypeName
    },
    bindMarket: function (agentId) {
      if (!agentId || agentId === '') {
        return ''
      }

      const marketNameList = this.marketList.map(market => {
        const agentIdList = get(market, 'agentIdList', [])
        if (agentIdList.includes(Number(agentId))) {
          return market.name
        }
      })
      const filtedMarketNameList = marketNameList.filter(Boolean)
      return filtedMarketNameList.join(', ')
    },
    onClosePopupButtonClick: function () {
      this.$emit('close')
    },
    getTotalWithStatus: function (status) {
      const emailListWithStatus = this.historyResultList.filter(item => item.sendStatus === status)

      return emailListWithStatus.length
    },
    changePage: function (page) {
      this.currentPage = page
    },
    bindEmailSendType: function (email) {
      const sendTo = get(this.emailHistory, 'sendTo', {})
      const ccList = get(sendTo, 'ccList', [])
      const bccList = get(sendTo, 'bccList', [])

      if (ccList.includes(email)) {
        return 'Cc:'
      }

      if (bccList.includes(email)) {
        return 'Bcc:'
      }

      return 'To:'
    },
    _filter: function () {
      const searchKeyList = ['email', 'sendDetail']
      const filteredResultList = filterDataByKeyword(this.historyResultList, this.keyword, searchKeyList)
      const filterByStatus = this._filterWithStatus()
      const filteredResultListByAgent = this._filerWithAgent(filteredResultList)

      return [...new Set([...filteredResultList, ...filterByStatus, ...filteredResultListByAgent])]
    },
    _filterWithStatus: function () {
      const statusList = [
        { statusText: 'processing', statusValue: EMAIL_STATUS.PROCESSING },
        { statusText: 'success', statusValue: EMAIL_STATUS.SUCCESS },
        { statusText: 'fail', statusValue: EMAIL_STATUS.FAIL }
      ]
      const filterStatusList = filterDataByKeyword(statusList, this.keyword, ['statusText'])
      if (filterStatusList.length > 0) {
        const filterStatusValueList = filterStatusList.map(item => item.statusValue)
        const filterHistoryResultList = this.historyResultList.filter((item) => {
          if (filterStatusValueList.includes(item.sendStatus)) {
            return true
          }
          return false
        })

        return filterHistoryResultList
      }

      return []
    },
    _filerWithAgent: function () {
      const searchKeyName = ['name']
      const filteredAgentList = filterDataByKeyword(this.agentList, this.keyword, searchKeyName)
      const filteredAgentTypeList = filterDataByKeyword(this.agentTypeList, this.keyword, searchKeyName)
      const filteredMarketList = filterDataByKeyword(this.marketList, this.keyword, searchKeyName)

      const agentTypeIdList = filteredAgentTypeList.map(item => item.id)
      const agentIdListInMarket = filteredMarketList.map(item => item.agentIdList)
      const explodeAgentIdListInMarket = []
      agentIdListInMarket.forEach((item) => {
        explodeAgentIdListInMarket.push(...item)
      })

      const agentListByType = this.agentList.filter((item) => {
        if (agentTypeIdList.includes(item.agentTypeId)) {
          return true
        }

        return false
      })

      const agentListByMarket = this.agentList.filter((item) => {
        if (explodeAgentIdListInMarket.includes(item.id)) {
          return true
        }

        return false
      })

      const filteredAgentResult = [...new Set([...filteredAgentList, ...agentListByType, ...agentListByMarket])]
      const filteredAgentResultIdList = filteredAgentResult.map(item => item.id)

      const historyResultListFilter = this.historyResultList.filter((item) => {
        const agentId = get(item, 'agentId', '')
        if (agentId === '') {
          return true
        }
        if (filteredAgentResultIdList.includes(item.agentId)) {
          return true
        }

        return false
      })

      return historyResultListFilter
    }
  }
}
</script>
<style scoped>
  .total-item {
    float: left;
    width: 24%;
    border: solid 1px #c0ddfb;
    border-width: 0px 0px 0px 1px;
    height: 100px;
    text-align: center;
  }
  .total-item:first-child {
    border-width: 0px !important;
  }
  .container-total-item {
    border: solid 1px #c0ddfb; width: 100%;
    height: 100px;
    margin-bottom: 20px;
    background: #ecf5ff;
    border-radius: 5px;
  }
  .filter-container {
    margin-bottom: 10px;
  }
  .total-item-text {
    padding-top: 30px;
  }
  .send {
    color: #409EFF;
  }
  .success {
    color: #67c23a;
  }
  .fail {
    color: #ff5e6f;
  }
  .processing {
    color: #ffca51;
  }
</style>
